import { render } from "./GetAccountAccessCode.vue?vue&type=template&id=6ff1fb8b&scoped=true"
import script from "./GetAccountAccessCode.vue?vue&type=script&lang=js"
export * from "./GetAccountAccessCode.vue?vue&type=script&lang=js"

import "./GetAccountAccessCode.vue?vue&type=style&index=0&id=6ff1fb8b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JavonOnuigbo\\mgs\\RabbitsfootOperatorApps\\cashierpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ff1fb8b"]])

export default __exports__